import React from 'react';

import routes from './routes';
import render from '@sketchpixy/rubix/lib/node/router';

render(routes, () => {
  //l20n.ready();
});

if (module.hot) {
  module.hot.accept('./routes', () => {
    // reload routes again
    require('./routes').default
    render(routes);
  });
}



// WEBPACK FOOTER //
// ./src/main.js